import { styled } from '../../Utilities';
import { getStyles } from './Separator.styles';
import { SeparatorBase } from './Separator.base';
export var Separator = styled(SeparatorBase, getStyles, undefined, {
    scope: 'Separator',
});
Separator.displayName = 'Separator';
//# sourceMappingURL=Separator.js.map